// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';

/**
 * @class Jsw.PasswordGenerator
 * @extends Jsw.Component
 */
export const PasswordGenerator = Class.create(Component, {
    _initConfiguration($super, config) {
        $super(config);
        this._passwordElement = $(this._getConfigParam('password', null));
        this._passwordConfirmationElement = $(this._getConfigParam('passwordConfirmation', null));
        this._generateButtonElement = $(this._getConfigParam('generateButton', null));
        this._generateButtonElement.observe('click', this._onGeneratePasswordClick.bind(this));
        this._showButtonElement = $(this._getConfigParam('showButton', null));
        this._showButtonElement.observe('click', this._onShowPasswordClick.bind(this));
        this._showPasswordVisible = true;
        this._showPasswordTitle = this._getConfigParam('showPasswordTitle', '');
        this._hidePasswordTitle = this._getConfigParam('hidePasswordTitle', '');
        this._passwordStrength = this._getConfigParam('passwordStrength', '');
        this._tag = 'span';
    },

    _onGeneratePasswordClick() {
        const password = this._generatePassword();
        this._passwordElement.value = password;
        if (this._passwordConfirmationElement) {
            this._passwordConfirmationElement.value = password;
        }
        this._passwordElement.fire('plesk:passwordGenerated');
    },

    _onShowPasswordClick() {
        if (this._showPasswordVisible) {
            try {
                this._passwordElement.writeAttribute('type', 'text');
            } catch (err) {
                // IE8 doesn't allow to change input type
            }
            if ('text' === this._passwordElement.type) {
                this._showButtonElement.down().update(this._hidePasswordTitle);
                this._showPasswordVisible = !this._showPasswordVisible;
            } else if (Prototype.Browser.IE && 'undefined' !== typeof prompt) {
                // eslint-disable-next-line no-alert
                const newPassword = prompt('', this._passwordElement.value);
                if (newPassword) {
                    this._passwordElement.value = newPassword;
                    if (this._passwordConfirmationElement) {
                        this._passwordConfirmationElement.value = newPassword;
                    }
                }
            }
        } else {
            this._passwordElement.writeAttribute('type', 'password');
            this._showButtonElement.down().update(this._showPasswordTitle);
            this._showPasswordVisible = !this._showPasswordVisible;
        }
    },

    _symbolClasses: {
        upper: new ObjectRange('A', 'Z').entries(),
        lower: new ObjectRange('a', 'z').entries(),
        number: new ObjectRange('0', '9').entries(),
        special: '!@#$%^&*?_~',
    },

    _generatePassword() {
        let password = '';
        const symbolClasses = ['upper', 'lower', 'lower', 'lower', 'number', 'number', 'special', 'number'];

        if ('Stronger' === this._passwordStrength) {
            symbolClasses.push('upper', 'upper', 'lower', 'lower', 'lower', 'lower', 'lower', 'lower');
        }

        symbolClasses.sort(function (a, b) {
            return Math.floor(b.length * Math.random()) - Math.floor(a.length * Math.random());
        });
        symbolClasses.each(function (i) {
            password += this._generateSymbol(i);
        }, this);
        return password;
    },

    _generateSymbol(symbolClass) {
        const index = Math.floor(this._symbolClasses[symbolClass].length * Math.random());
        return this._symbolClasses[symbolClass][index];
    },
});



// WEBPACK FOOTER //
// ./jsw/password-generator.js